import {Injectable} from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class UserAreaService {
  public isUserAreaEnabled = false;
}
